"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TakeoverHeader = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var TakeoverHeader = function (_a) {
    var actions = _a.actions, backLabel = _a.backLabel, className = _a.className, onBack = _a.onBack, onClose = _a.onClose, theme = _a.theme, title = _a.title, props = __rest(_a, ["actions", "backLabel", "className", "onBack", "onClose", "theme", "title"]);
    var TakeoverHeaderClasses = classnames_1.default('TakeoverHeader', className, "TakeoverHeader--" + theme);
    return (react_1.default.createElement("div", __assign({ className: TakeoverHeaderClasses }, props),
        react_1.default.createElement("div", { className: "TakeoverHeader__left" }, onBack && (react_1.default.createElement(__1.BackLink, { className: "TakeoverHeader__back-link", pageLabel: backLabel, onClick: onBack }))),
        react_1.default.isValidElement(title) ? (title) : (react_1.default.createElement(__1.Headline, { className: "TakeoverHeader__title" }, title)),
        react_1.default.createElement("div", { className: "TakeoverHeader__right" },
            actions && (react_1.default.createElement("div", { className: "TakeoverHeader__actions" }, actions)),
            onClose && (react_1.default.createElement(__1.Button, { fill: "subtle", className: "TakeoverHeader__close", iconName: "clear", size: "xsmall", onClick: onClose })))));
};
exports.TakeoverHeader = TakeoverHeader;
exports.TakeoverHeader.defaultProps = {
    theme: 'dark',
};
//# sourceMappingURL=TakeoverHeader.js.map